import {Rb2bService} from '../../libs/ui/src/index';

import {client} from '../apiService';
const _Rb2bService = new Rb2bService({client});
export {_Rb2bService as Rb2bService};
